import { render, staticRenderFns } from "./alt-search-goods.vue?vue&type=template&id=78358de7&scoped=true&"
import script from "./alt-search-goods.ts?vue&type=script&lang=ts&"
export * from "./alt-search-goods.ts?vue&type=script&lang=ts&"
import style0 from "./alt-search-goods.vue?vue&type=style&index=0&id=78358de7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78358de7",
  null
  
)

export default component.exports